import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import * as api from './api'

export const getList = createAsyncThunk('deductibleTaxReport/GET_LIST', async (request, thunkAPI) => {
  const { data, error } = await api.getList({ ...request })
  if (error) return thunkAPI.rejectWithValue(error)
  return data
})
export const get = createAsyncThunk('deductibleTaxReport/GET', async (id, thunkAPI) => {
  const { data, error } = await api.get(id)
  if (error) return thunkAPI.rejectWithValue(error)
  return data
})

export const slice = createSlice({
  name: 'deductibleTaxReport',
  initialState: {
    list: [],
    isListLoading: false,
    error: null,
    totalSize: 0,
    model: null,
    isModelLoading: false,
    isLoading: false,
  },
  extraReducers: builder => {
    builder
      .addCase(getList.pending, state => {
        state.isListLoading = true
        state.error = null
      })
      .addCase(getList.fulfilled, (state, action) => {
        state.isListLoading = false
        state.list = action.payload.data
        state.totalSize = action.payload.totalCount
      })
      .addCase(getList.rejected, (state, action) => {
        state.isListLoading = false
        state.error = action.payload
      })
      .addCase(get.pending, state => {
        state.isLoading = true
        state.error = null
      })
      .addCase(get.fulfilled, (state, action) => {
        state.isLoading = false
        state.model = action.payload
      })
      .addCase(get.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload
      })
  },
})

export const listSelector = state => state.deductibleTaxReport.list
export const modelSelector = state => state.deductibleTaxReport.model
export const errorSelector = state => state.deductibleTaxReport.error
export const isListLoadingSelector = state => state.deductibleTaxReport.isListLoading
export const isModelLoadingSelector = state => state.deductibleTaxReport.isLoading
export const totalSizeSelector = state => state.deductibleTaxReport.totalSize
export const reducer = slice.reducer
